import React from 'react'
import ContainerUnauthenticated from 'containers/Unauthenticated'
import FormCore from 'components/Form/Core'
import Button from 'components/Form/Button'
import useController from './controller'
import { Screen, Intro, FormPanel, Actions, Message } from '../CompleteProfile/styled'

export default function ChangePassword({ area }) {
  const { t, formRef, formItems, loading, saving, ready, error, save, logout } = useController(area)
  return (
    <ContainerUnauthenticated success>
      <Screen aria-busy={loading || saving}>
        <Intro>
          <span>{t(`area_${area}_name`)}</span>
          <h1>{t('password_change_title')}</h1>
          <p>{t('password_change_description')}</p>
        </Intro>
        <FormPanel>
          {loading ? <p role="status">{t('area_loading')}</p> : ready ? (
            <form onSubmit={event => { event.preventDefault(); save() }}>
              <FormCore ref={formRef} formItems={formItems} disabled={saving} />
              <button type="submit" hidden aria-hidden="true" tabIndex={-1} />
              <Actions><Button color="blue" onClick={save} loading={saving}>{t('password_change_save')}</Button></Actions>
            </form>
          ) : null}
          {error ? <Message role="alert">{t('password_change_error')}</Message> : null}
          <Actions><Button link onClick={logout} disabled={saving}>{t('area_sign_out')}</Button></Actions>
        </FormPanel>
      </Screen>
    </ContainerUnauthenticated>
  )
}
